module.exports = __webpack_public_path__ + "static/img/5.91ab65f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/eng/5.png
// module id = lsCF
// module chunks = 0